import apiClient from './apiClient';

export async function fetchVulnerabilities() {
  const { data } = await apiClient.get('/vulnerabilities/scans');
  return data;
}

export async function fetchScanSummary() {
  const { data } = await apiClient.get('/vulnerabilities/scan-summary');
  return data;
}

export async function triggerScan(targetUrl) {
  const { data } = await apiClient.post('/vulnerabilities/scan', { target_url: targetUrl });
  return data;
}
